import { client } from "./api";

export async function getUfs(): Promise<IIbgeStates[]> {
  const api = client();
  
  const response = await api.get<IIbgeStates[]>(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome"
  );

  if (!response) {
    throw new Error();
  }

  return response.data;
}

export interface IIbgeStates {
  id: number;
  nome: string;
  sigla: string;
  regiao: {
    id: number;
    nome: string;
    sigla: string;
  }
}